const regex = /^.+\D?(?<number>\d+)$/

const getNameOfDuplicatedComponent = (componentName: string) => {
	const hasNumberAsLastPart = componentName.match(regex)

	if (!hasNumberAsLastPart) return componentName

	const {
		groups: { number },
	} = regex.exec(componentName)

	const [, ...reversedParts] = componentName.split(number).reverse()

	return [Number(number) + 1, reversedParts.reverse().join(number)].reverse().join("")
}

export default getNameOfDuplicatedComponent
